export const RECIPE_QUERY_SEARCH_TERM = 'recipeSearch';
export const RECIPE_SEARCH_PATH = '/ecom/recipes/search';
export const RECIPE_SEARCH_ID = 'recipe-search';
